import CustomerAccountPage from '@components/containers/b2b/CustomerAccountPage';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const B2bCustomerAccount: FC = () => (
    <AppLayout>
        <CustomerAccountPage />
    </AppLayout>
);

export default B2bCustomerAccount;
